import React, { useEffect, useState } from 'react';
import UsersLists from './UserInfo';
import RolesControlPanel from './RolesControlPanel';
import EnhancedTab from '../../../../lib/designSystem/TabSimulation';
import { useNavigate, useParams } from 'react-router-dom';

const tabs = [
  {
    label: 'Usuarios',
    component: <UsersLists />,
    path: 'summary',
  },
  { label: 'Roles', component: <RolesControlPanel />, path: 'roles' },
];

const UsersSettings: React.FC = () => {
  const navigate = useNavigate();
  const { subPage } = useParams<{ page: string; subPage: string }>();
  const [startValue, setStartValue] = useState(0);

  const handleNavigation = (index: number) => {
    navigate(`/settings/users/${tabs[index].path}`);
  };

  useEffect(() => {
    let subPageIndex = tabs.findIndex((x: any) => x.path === subPage);
    subPageIndex = subPageIndex === -1 ? 0 : subPageIndex;
    handleNavigation(subPageIndex);
    setStartValue(subPageIndex);
  }, []);

  return (
    <div>
      <EnhancedTab
        startValue={startValue}
        tabs={tabs}
        onTabChange={handleNavigation}
      />
    </div>
  );
};

export default UsersSettings;
